var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Input } from "@mui/joy";
/** <b>Composant en mode consultation/detail d'un champ de type link</b>*/
export default function PasswordFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldClassName = _a.fieldClassName, componentClassName = _a.componentClassName, fieldMetadata = _a.fieldMetadata, isReport = _a.isReport;
    var defaultValue = useMemo(function () {
        if (!record) {
            return "";
        }
        return isReport
            ? record.value
            : record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    var _b = useState(""), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue(defaultValue || "");
    }, [defaultValue]);
    return (_jsx("div", __assign({ className: "flex-1 ".concat(fieldClassName ? fieldClassName : "") }, { children: _jsx(Input, { type: "password", autoFocus: true, value: value, size: "sm", className: "w-full ".concat(componentClassName ? componentClassName : "text-left "), onChange: function (event) {
                var _a;
                var newValue = event.target.value;
                setValue(newValue);
                if (onUpdate) {
                    onUpdate((_a = {}, _a[fieldName] = newValue, _a));
                }
            } }) })));
}
